module.exports = __webpack_public_path__ + "img/logo-new.e7a44fd5.png";